import { render } from "./DialogBox.vue?vue&type=template&id=7f901520"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__